export const dateFormat = "YYYY-MM-DD";

export const scannerConfigs = {
  timeOut: "5000",
  quality: "10",
  templateFormat: "ISO",
  imageWSQRate: "0.75",
  secugen_lic: "",
};